import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Search, Target, PenTool, UserCheck, Check, ArrowRight } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: Search,
    title: 'Hidden Market Access',
    desc: 'Over 70% of executive roles are never publicly advertised. Our proprietary intelligence network surfaces opportunities invisible to the broader market.',
    features: ['Access unadvertised roles', 'Direct decision-maker introductions', 'Proprietary intelligence network', 'Board-level opportunities'],
    featured: true
  }, {
    icon: Target,
    title: 'Executive Role Matching',
    desc: 'We identify the precise intersection of your capabilities, aspirations, and cultural alignment — then architect introductions with surgical precision.',
    features: ['Precision-targeted matching', 'Cultural alignment analysis', 'Compensation benchmarking', 'Confidential introductions']
  }, {
    icon: PenTool,
    title: 'Career Strategy & Positioning',
    desc: 'Your career narrative is as important as your track record. We refine your executive identity and position you as the inevitable choice.',
    features: ['Executive narrative refinement', 'Value proposition development', 'Market positioning strategy', 'Interview preparation']
  }, {
    icon: UserCheck,
    title: 'Profile & Presence Optimization',
    desc: 'From board-ready profiles to discreet market signaling, we ensure your professional presence reflects the leader you are becoming.',
    features: ['Board-ready profile creation', 'Digital presence audit', 'Discreet market signaling', 'Personal brand strategy']
  }];
  return <Section background="white" id="services" className="py-24" data-id="element-361">
      <FadeIn className="text-center mb-20 max-w-3xl mx-auto" data-id="element-362">
        <span className="text-accent-500 text-xs font-bold uppercase tracking-[0.2em] block mb-4" data-id="element-363">
          Our Expertise
        </span>
        <h2 className="text-3xl md:text-5xl font-serif text-ink-900 mb-6" data-id="element-364">
          How We Serve You
        </h2>
        <p className="text-lg text-body leading-relaxed" data-id="element-365">
          A comprehensive suite of executive advisory services designed to
          navigate the complexities of senior leadership transitions.
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-366">
        {services.map((service, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-367">
            <div className={`
              group relative h-full p-8 md:p-10 flex flex-col transition-all duration-300
              ${service.featured ? 'bg-white border-t-4 border-accent-400 shadow-xl ring-1 ring-black/5' : 'bg-white border border-sage-200 hover:border-accent-400/30 hover:shadow-lg'}
            `} data-id="element-368">
              {/* Step Number */}
              <div className="absolute top-6 right-8 text-6xl font-serif font-bold text-sage-100 group-hover:text-sage-200/50 transition-colors select-none" data-id="element-369">
                0{index + 1}
              </div>

              {/* Header */}
              <div className="relative z-10 mb-8" data-id="element-370">
                <div className={`
                  w-14 h-14 rounded-lg flex items-center justify-center mb-6 transition-colors
                  ${service.featured ? 'bg-accent-400 text-white' : 'bg-sage-100 text-ink-700 group-hover:bg-accent-400 group-hover:text-white'}
                `} data-id="element-371">
                  <service.icon className="w-7 h-7" data-id="element-372" />
                </div>

                <h3 className="text-2xl font-serif font-bold text-ink-900 mb-4" data-id="element-373">
                  {service.title}
                </h3>

                <p className="text-body leading-relaxed mb-8 min-h-[80px]" data-id="element-374">
                  {service.desc}
                </p>
              </div>

              {/* Features List */}
              <div className="mt-auto relative z-10 pt-8 border-t border-sage-100" data-id="element-375">
                <ul className="space-y-4 mb-8" data-id="element-376">
                  {service.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-377">
                      <Check className="w-5 h-5 text-accent-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-378" />
                      <span className="text-sm text-ink-700 font-medium" data-id="element-379">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <div className="flex items-center text-accent-500 text-sm font-bold uppercase tracking-widest group-hover:translate-x-2 transition-transform cursor-pointer" data-id="element-380">
                  Learn More <ArrowRight className="w-4 h-4 ml-2" data-id="element-381" />
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}